import { useCallback, useState } from 'react';
import type { ConfirmRequest } from '../components/ConfirmDialog';

/**
 * Returns:
 *   confirm(req) — show the modal, returns a Promise<boolean>
 *   request      — current modal payload (or null)
 *   resolve      — call with true/false to close + resolve the promise
 */
export function useConfirm() {
  const [request, setRequest] = useState<ConfirmRequest | null>(null);
  const [resolver, setResolver] = useState<((ok: boolean) => void) | null>(null);

  const confirm = useCallback((req: ConfirmRequest): Promise<boolean> => {
    return new Promise<boolean>(resolve => {
      setRequest(req);
      setResolver(() => resolve);
    });
  }, []);

  const resolve = useCallback((ok: boolean) => {
    if (resolver) resolver(ok);
    setRequest(null);
    setResolver(null);
  }, [resolver]);

  return { confirm, request, resolve };
}
